unit ShowGrafik;

interface

uses System.SysUtils, System.Variants, System.Classes, Vcl.Graphics,
     Vcl.Controls, Vcl.Forms, Vcl.Dialogs, WebBasis2, Data.DB, XData.Web.JsonDataset, XData.Web.Dataset,
     VCL.TMSFNCCustomComponent, VCL.TMSFNCBitmapContainer, Vcl.Imaging.GIFImg, WEBLib.Controls,
     WEBLib.Dialogs, WEBLib.ExtCtrls, Vcl.StdCtrls, WEBLib.StdCtrls, VCL.TMSFNCTypes, VCL.TMSFNCUtils,
     VCL.TMSFNCGraphics, VCL.TMSFNCGraphicsTypes, VCL.TMSFNCCustomControl, VCL.TMSFNCToolBar, web ;

[async] procedure Show_Grafik( sUrl : String ); async;

type
  TfrmShowGrafik = class(TForm)
    WebPanel1: TPanel;
    ImgContr: TImageControl;
    btnClose: TTMSFNCToolBarButton;
    procedure WebFormShow(Sender: TObject);
    procedure btnCloseClick(Sender: TObject);
  private

  public
    sUrl : String;

  protected procedure LoadDFMValues; override; end;

var frmShowGrafik: TfrmShowGrafik;

implementation

{$R *.dfm}

uses UnitMain ;

//====================================================================================================================//

procedure Show_Grafik( sUrl : String );
begin

  console.log('1') ;

  frmShowGrafik := TfrmShowGrafik.Create(application);
  frmShowGrafik.Caption := 'Bild: ';
  frmShowGrafik.sUrl    := sUrl;
  frmShowGrafik.Popup   := True;
  //frmShowGrafik.Border  := fbDialogSizeable;

  // used to manage Back button handling to close subform
  //window.location.hash := 'subform';

  console.log('2');

  // load file HTML template + controls
  await( TfrmShowGrafik, frmShowGrafik.Load() );

  console.log('3') ;

   frmShowGrafik.Caption := 'neuer ';

//  await( frmMitarbeiterEdit.Daten_Ins_Formular_Paket );

  Try
  console.log('4')  ;
    // excute form and wait for close
    await( TModalResult, frmShowGrafik.Execute);
//


    //Änderungen speichern
    //If frmShowGrafik.ModalResult = mrOK then frmShowGrafik.Daten_Speichern;
//
  Finally
    frmShowGrafik.Free;
  End;

end;

//====================================================================================================================//

procedure TfrmShowGrafik.btnCloseClick(Sender: TObject);
begin
  inherited;
  Close;
end;

//====================================================================================================================//

procedure TfrmShowGrafik.WebFormShow(Sender: TObject);
begin
  inherited;

  ImgContr.Url := self.sUrl;

  self.Left   := 0;
  self.Top    := 0;
  self.Width  := window.InnerWidth;
  self.Height := window.InnerHeight;
  Self.Resize;

end;

//====================================================================================================================//

procedure TfrmShowGrafik.LoadDFMValues;
begin
  inherited LoadDFMValues;

  ImgContr := TImageControl.Create(Self);
  WebPanel1 := TPanel.Create(Self);
  btnClose := TTMSFNCToolBarButton.Create(Self);

  ImgContr.BeforeLoadDFMValues;
  WebPanel1.BeforeLoadDFMValues;
  btnClose.BeforeLoadDFMValues;
  try
    Name := 'frmShowGrafik';
    Width := 640;
    Height := 480;
    Caption := 'Dokument';
    SetEvent(Self, 'OnShow', 'WebFormShow');
    ImgContr.SetParentComponent(Self);
    ImgContr.Name := 'ImgContr';
    ImgContr.AlignWithMargins := True;
    ImgContr.Left := 3;
    ImgContr.Top := 57;
    ImgContr.Width := 634;
    ImgContr.Height := 420;
    ImgContr.WidthStyle := ssAuto;
    ImgContr.HeightPercent := 100.000000000000000000;
    ImgContr.WidthPercent := 100.000000000000000000;
    ImgContr.Align := alClient;
    ImgContr.ChildOrder := 1;
    WebPanel1.SetParentComponent(Self);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 0;
    WebPanel1.Top := 0;
    WebPanel1.Width := 640;
    WebPanel1.Height := 54;
    WebPanel1.Align := alTop;
    WebPanel1.ChildOrder := 2;
    WebPanel1.TabOrder := 0;
    btnClose.SetParentComponent(WebPanel1);
    btnClose.Name := 'btnClose';
    btnClose.Left := 9;
    btnClose.Top := 5;
    btnClose.Width := 125;
    btnClose.Height := 44;
    btnClose.Cursor := crHandPoint;
    btnClose.ParentDoubleBuffered := False;
    btnClose.DoubleBuffered := True;
    btnClose.Font.Charset := DEFAULT_CHARSET;
    btnClose.Font.Color := clWindowText;
    btnClose.Font.Height := -11;
    btnClose.Font.Name := 'Segoe UI';
    btnClose.Font.Style := [];
    btnClose.ParentColor := True;
    btnClose.TabOrder := 0;
    SetEvent(btnClose, Self, 'OnClick', 'btnCloseClick');
    btnClose.Text := '';
    btnClose.Bitmaps.Clear;
    with btnClose.Bitmaps.Add do
    begin
      Bitmap.LoadFromFile('ShowGrafik.btnClose.Bitmaps.Bitmap.png');
      BitmapName := 'LINKS';
    end;
    btnClose.BitmapVisible := True;
    btnClose.ControlIndex := 0;
  finally
    ImgContr.AfterLoadDFMValues;
    WebPanel1.AfterLoadDFMValues;
    btnClose.AfterLoadDFMValues;
  end;
end;

end.
